import { render, staticRenderFns } from "./VehicleVinDecoder.vue?vue&type=template&id=00b94b28&"
import script from "./VehicleVinDecoder.vue?vue&type=script&lang=js&"
export * from "./VehicleVinDecoder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports